export const createPopupMessage = (lngTag) => {
    const div = document.createElement('div');
    div.classList.add('popup-message');
    div.style = 'padding: 2rem; background: #fff; border-radius: 3px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex; align-items: center; justify-content: center; box-shadow: 0 3px 5px #939393; color: red; font-weight: 700; z-index: 100; text-align: center; width: 90%; max-width: 500px;'

    const textMessageElement = document.createElement('span');
    textMessageElement.setAttribute('lng-tag', lngTag);
    div.appendChild(textMessageElement);

    const close = document.createElement('div');
    close.innerHTML = 'X';
    close.style = 'position: absolute; right: 6px; top: 6px; cursor: pointer; color: #000; font-size: 1rem;'
    close.classList.add('close-popup')
    div.appendChild(close);

    const opacity = document.createElement('div');
    opacity.id = 'popup-opacity';
    opacity.style = 'position: fixed; width: 100%; min-height: 100vh; background-color: #00000096; z-index: 90; left: 0; top: 0;'
    opacity.classList.add('close-popup')

    document.body.appendChild(div);
    document.body.appendChild(opacity);

    document.querySelectorAll('.close-popup').forEach((e => {
        e.addEventListener('click', () => {
            opacity.remove();
            div.remove();
        })
    }))
}